const anyWindow: any = window;
declare const angular: any;

// get the injector. If running with an AngularJS core the injector will be the AngularJS injector. If running with an
// Angular core, the injector is exposed globally in a window.FormbirdServiceInjector object. Once we have moved all customers
// to an Angular core, we can remove the searching for an AngularJS injector

// first try getting the global formbird service injector which will be defined if running with an Angular only core
let injector = anyWindow.FormbirdServiceInjector;
let actualChangedDocumentService;

// if injector is not defined, get the AngularJS injector, this will happen if running with an AngularJS core
if (!injector) {
    const element = document.querySelectorAll('#bodyAngularJS div[ui-view]');
    injector = angular.element(element).injector();

    // changedDocumentService doesn't exist in AngularJS, so create a wrapper that sets the value in the document
    actualChangedDocumentService = {
        valueChanged(component, value: any, controlName?: string, options?: any) {
            component.document[component.componentDefinition.name] = value;
        }
    };
} else {
    actualChangedDocumentService = injector.get('ChangedDocumentService');
}

export const searchService = injector.get('SearchService');
export const changedDocumentService = actualChangedDocumentService;